import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import navigateBack from 'Data/actionCreators/explorer/navigateBack';
import setJourneyStage from 'Data/actionCreators/journey/setJourneyStage';
import setJourneyStop from 'Data/actionCreators/journey/setJourneyStop';
import setRouteParameters from 'Data/actionCreators/journey/setRouteParameters';
import setSearchLocation from 'Data/actionCreators/journey/setSearchLocation';
import setScanLocation from 'Data/actionCreators/journey/setScanLocation';
import setTrackUserLocation from 'Data/actionCreators/journey/setTrackUserLocation';
import hideCard from 'Data/actionCreators/kiosk/hideCard';
import navigate from 'Data/actionCreators/kiosk/navigate';
import setLocationTooFar from 'Data/actionCreators/explorer/setLocationTooFar';
import setExplorerLoaded from 'Data/actionCreators/explorer/setExplorerLoaded';
import selectRouteOption from 'Data/actionCreators/kiosk/selectRouteOption';
import setIsMapUpdateAvailable from 'Data/actionCreators/setIsMapUpdateAvailable';
import setNavMode from 'Data/actionCreators/setNavMode';
import {CONFIG_DATA_BASE_KEYS} from 'Utils/constants';
import {prepareDataForMapView} from 'Data/services/fetchNavMap';
import {getExplorerNavigation} from 'Utils/explorer/getNavigation';
import getQuickLinks from 'Components/common/QuickLinks/getQuickLinks';
import setQuickLink from 'Data/actionCreators/kiosk/setQuickLink';
import setTakeMeThereEventId from 'Data/actionCreators/explorer/setTakeMeThereEventId';
import Explorer from './Explorer';

const getConfig = state => state.pageState.layout.config || {};

const getMapDataForKiosk = createSelector(
    [getConfig],
    ({digitalSignId, navMapWithLocations, tenantFeatures, events}) =>
        prepareDataForMapView({
            navMapWithLocations,
            events,
            tenantFeatures,
            navMapConfig: navMapWithLocations?.config,
            kioskDeviceId: digitalSignId,
            isExplorer: true,
        })
);

const mapStateToProps = (state, props) => {
    // data hasn't loaded yet, so none of states are populated

    return {
        mapboxStyles: state.mapLayers.mapboxStyles,
        mapDataForKiosk: getMapDataForKiosk(state),
        config: state.pageState.layout.config,
        directionsJourneyIndex: state.pageState.explorerMap.directionsJourneyIndex,
        quickLinks: getQuickLinks(state),
        searchFilters:
            state.pageState?.layout?.config?.signConfig[CONFIG_DATA_BASE_KEYS.WITH_INHERITANCE]
                ?.search?.searchFilters || [],
        numberOfEvents: state.pageState.layout.config?.events?.length || 0,
        initialMapTheme: state.pageState.explorerMap.initialMapTheme,
        searchLocation: state.pageState.explorerMap.searchLocation,
        scanLocation: state.pageState.explorerMap.scanLocation,
        userSharedLocation: state.pageState.explorerMap.userSharedLocation,
        journey: state.pageState.explorerMap.journey,
        navMap: state.mapLayers.navMap,
        isNavMapLoaded: state.mapLayers.isNavMapLoaded,
        navMode: state.pageState.explorerMap.navMode,
        locationTooFar: state.pageState.explorerMap.locationTooFar,
        navigationHistory: state.pageState.explorerMap.navigationHistory,
        selectedQuickLink: state.pageState.explorerMap.selectedQuickLink,
        query: state.pageState.explorerMap.query,
        activeScene: state.pageState.explorerMap.activeScene,
        isMapUpdateAvailable: state.pageState.shared.isMapUpdateAvailable,
        navigation: getExplorerNavigation(state),
        url: props.url,
        displayMapStyleControl:
            state.pageState.layout.config?.signConfig[CONFIG_DATA_BASE_KEYS.WITH_INHERITANCE]
                ?.mapConfig?.displayMapStyleControl,
        mapCenter: state.pageState.layout.config?.settings?.mapCenter,
        externalLocations:
            state.pageState.layout.config?.signConfig?.[CONFIG_DATA_BASE_KEYS.WITH_INHERITANCE]
                ?.externalLocations,
    };
};

export default connect(
    mapStateToProps,
    {
        navigateBack,
        navigate,
        setNavMode,
        setJourneyStage,
        setJourneyStop,
        setTrackUserLocation,
        setSearchLocation,
        setScanLocation,
        selectRouteOption,
        setRouteParameters,
        setExplorerLoaded,
        setIsMapUpdateAvailable,
        setLocationTooFar,
        setQuickLink,
        setTakeMeThereEventId,
        hideCard,
    }
)(Explorer);
